$(document).ready(function() {
  
  // hack to fix nav icons display. This is a known issue, reference - https://github.com/OwlCarousel2/OwlCarousel2/issues/1809
  $("#header1 .owl-nav").removeClass("disabled");
  $("#header1 .owl-nav").click(function() {
    $(this).removeClass("disabled");
  });

  // update hidden field for form processing in plugin
  $("#fromEmail").change(function() {
    $("#from-email-hidden").val($(this).val());
  });

  // Hash jumping with header navi offset
  function hashJump () {
    var $hash = window.location.hash;
    if ($hash) {
      var headerHeight = $(document).find('header nav.navbar').outerHeight();
      var target = $hash;
      var targetOffset = $(target).offset().top - (headerHeight + 10);
      var currScrollOffset = $(window).scrollTop();
      $('html, body').animate({
        scrollTop: targetOffset
      }, Math.abs(currScrollOffset - targetOffset) * 0.25);
    }
  }

  hashJump();

  $('a.hashJump').on('click', function(e) {
    e.preventDefault();
    window.location.hash = $(this).attr('href');
    hashJump();
  });
 
  $('#activmap-location').on('click', function(e) {
    this.select();
  });

  // If browser IE11
  if(!!navigator.userAgent.match(/Trident.*rv\:11\./)){
    $('a[data-lightbox="image-group"]').click(function(e){
      e.preventDefault();
      return false;
    });

    if($('a[data-lightbox="image-group"]').length >= 1){
      $('a[data-lightbox="image-group"]').css({'cursor': 'default'});
    }
  }
});


// WEBPACK FOOTER //
// ./source/assets/js/modules/miscellaneous.js